import { createFileRoute } from '@tanstack/react-router'

import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/companies')({
	validateSearch: paginatedSearchWithSort(['name', 'email', 'phone', 'externalId', 'settlementCount']),
	staticData: {
		crumb: ({ context: { L } }) => L.Companies.Title()
	}
})
